import { GameStatues, IGame } from "@grassrootly/api/entities/IGame";
import { GetGameByIdPayload } from "@grassrootly/api/gateways/game";
import server from "../Server";
import withErrorCheck from "../CheckError";

export const GetGameById = async (payload: GetGameByIdPayload): Promise<IGame | null> => {
  // Fetch game data from the game_overview view
  const gameOverview = withErrorCheck(
    await server.from("game_overview").select("*").eq("game_id", payload.id)
  )[0];
  
  if (!gameOverview) {
    return null;
  }

  // Keep attendance queries separate as requested
  const order: any = { key: "attended", opts: { ascending: false, nullsFirst: false } };
  if (gameOverview.game_status === GameStatues.FINALIZED) {
    order.key = "points_earned";
    order.opts = { ascending: false };
  }
  
  const gameAttendees = withErrorCheck(
    await server
      .from("GameAttendances")
      .select("*")
      .eq("game_id", gameOverview.game_id || 0)
      .order(order.key, order.opts)
  );
  
  const players = withErrorCheck(
    await server
      .from("Players")
      .select("*")
      .in(
        "id",
        gameAttendees.map((ga) => ga.player_id)
      )
  );

  const att = gameAttendees
    .filter((ga) => ga.game_id == gameOverview.game_id)
    .map((ga) => {
      return {
        ...ga,
        player: players.find((p) => p.id == ga.player_id)!,
      };
    });

  // Fetch host_group_id and visitor_group_id from the Games table for ORGANIZATION_MATCH
  const gameDetails = withErrorCheck(
    await server
      .from("Games")
      .select("*")
      .eq("id", gameOverview.game_id)
      .single()
  );

  // Map the game_overview data to the IGame interface
  return {
    id: gameOverview.game_id,
    created_at: gameOverview.game_created_at || "",
    datetime: gameOverview.game_datetime,
    group_id: gameOverview.group_id,
    host_score: gameOverview.host_score,
    location: gameOverview.game_location,
    notes: gameOverview.game_notes,
    status: gameOverview.game_status,
    visitor_score: gameOverview.visitor_score,
    game_type: gameOverview.game_type,
    host_team_name: gameOverview.host_team_name,
    visitor_team_name: gameOverview.visitor_team_name,
    playing_as_host: gameOverview.playing_as_host,
    season_id: gameOverview.game_season_id || null,
    season_information: gameOverview.season_information,
    organization_logo: gameOverview.organization_logo,
    host_team_logo: gameOverview.host_team_logo,
    visitor_team_logo: gameOverview.visitor_team_logo,
    host_group_id: (gameDetails as any)?.host_group_id || null,
    visitor_group_id: (gameDetails as any)?.visitor_group_id || null,
    group: {
      id: gameOverview.group_id,
      name: gameOverview.group_name,
      created_at: gameOverview.group_created_at || "",
      group_logo: gameOverview.group_logo || null,
    },
    attendees: att.sort((a, b) => a.player_id > b.player_id ? 1 : a.player_id < b.player_id ? -1 : 0),
  };
};
